export default "__VITE_ASSET__CxZDERpP__"